import { CampusMap } from '@features/campus-map/components/CampusMap'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { zodValidator } from '@tanstack/zod-adapter'

const mapSearchSchema = z.object({
  poiId: z.coerce.number().int().positive().optional(),
})

export const Route = createFileRoute('/_layout/map')({
    validateSearch: zodValidator(mapSearchSchema),
    component: RouteComponent,
    staticData: {
        title: 'Campus Map',
    },
})

function RouteComponent() {
  const { poiId } = Route.useSearch()
  return <CampusMap initialPoiId={poiId ?? null} />
}
